import { render } from "./TrainingsmodusModalComponent.vue?vue&type=template&id=e5b3efd6"
import script from "./TrainingsmodusModalComponent.vue?vue&type=script&lang=js"
export * from "./TrainingsmodusModalComponent.vue?vue&type=script&lang=js"

import "./TrainingsmodusModalComponent.vue?vue&type=style&index=0&id=e5b3efd6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__